import axios from "../../axios";
import { API, API_CATALOG_API } from "../../constants";
import { BookingStatus } from "../../helpers/statuses";
import i18n from "../../i18n";
import * as actionTypes from "./actionTypes";

export const setRevenues = (revenues) => {
  return {
    type: actionTypes.SET_REVENUE,
    revenues: revenues,
  };
};

export const setRevenuesLoading = () => {
  return {
    type: actionTypes.FETCH_REVENUE_STARTING,
  };
};

export const fetchRevenueFailed = () => {
  return {
    type: actionTypes.FETCH_REVENUE_FAILED,
    revenues: [],
  };
};

export const initRevenues = (depositId, month) => {
  return (dispatch) => {
    dispatch(setRevenuesLoading());
    axios
      .get(`${API}${i18n.language}/angel/revenue/${depositId}/${month}`)
      .then((response) => {
        const transformedRevenue =
          response.data !== null
            ? response.data.map((item) => ({
                depositId: item.storage_id,
                depositName: item.storage_name,
                orderId: item.order_id,
                bags: item.bags,
                dropOff: item.drop_off,
                pickUp: item.pick_up,
                orderDate: item.order_date,
                customerName: item.customer_name,
                price: item.amount,
                /**
                 * currently we do not want to see pending label on angel revenues anymore
                 * so hardcode false in that field
                 *
                 *  isPending: item.is_pending,
                 */
                isPending: false,
                tips: item.tipsRate,
                isWalkin: item.isWalkin,
                isFlexible: !!item.flexibleRate,
                flexibleRate: item.flexibleRate,
                status: (() => {
                  switch (item.status) {
                    case "ready_for_checkin":
                      return BookingStatus.READY_FOR_CHECKIN;
                    case "suspended":
                      return BookingStatus.SUSPENDED;
                    case "closed":
                      return BookingStatus.CLOSED;
                    case "refunded":
                      return BookingStatus.REFUNDED;
                    case "checked_in":
                      return BookingStatus.CHECKED_IN;
                    case "completed":
                      return BookingStatus.COMPLETED;
                    case "no_show":
                      return BookingStatus.NO_SHOW;
                    default:
                      throw new Error("unexpected booking status");
                  }
                })(),
              }))
            : [];
        dispatch(setRevenues(transformedRevenue));
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchRevenueFailed());
      });
  };
};

export const setRevenuesPerformance = (total) => {
  return {
    type: actionTypes.SET_REVENUE_PERFORMANCE,
    total: total,
  };
};

export const setRevenuesPerformanceLoading = () => {
  return {
    type: actionTypes.FETCH_REVENUE_PERFORMANCE_STARTING,
  };
};

export const fetchRevenuePerformanceFailed = () => {
  return {
    type: actionTypes.FETCH_REVENUE_PERFORMANCE_FAILED,
  };
};
export const getRevenuesPerformance = (storageId, month, year) => {
  return (dispatch) => {
    // ${moment().format('YYYY/MM')}
    dispatch(setRevenuesPerformanceLoading());
    axios
      .get(`${API}${i18n.language}/angel/performance`, {
        params: { storageId: storageId, month: month, year: year },
      })
      .then((response) => {
        dispatch(setRevenuesPerformance(response.data));
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchRevenuePerformanceFailed());
      });
  };
};
